import {allPendingReviewRoute,informationDomainRoutes} from '@myfm/domain';
export type IntakeEvaluatedScope={kind:'portfolio'}|{kind:'building';id:string};
export function assertIntakeResponseScope(value:{evaluatedScope?:IntakeEvaluatedScope},building:string|undefined){
  if(building&&(value.evaluatedScope?.kind!=='building'||value.evaluatedScope.id!==building))throw new Error('The document response did not confirm the selected building. Refresh before continuing.');
}
export function intakeQueueReturn(value:string,building:string|undefined){
  try{
    const url=new URL(value,'https://staff.invalid');
    if(!value.startsWith('/')||value.startsWith('//')||value.includes('\\')||url.origin!=='https://staff.invalid'||![...Object.values(informationDomainRoutes),allPendingReviewRoute].includes(url.pathname))return '';
    const scopes=[...url.searchParams.getAll('building'),...url.searchParams.getAll('developmentId')];
    if(scopes.some(scope=>scope!==(building??'')))return '';
    url.searchParams.delete('developmentId');
    if(building)url.searchParams.set('building',building);
    return url.pathname+url.search;
  }catch{return '';}
}
